const isValidIcid = (queryParam, request) => {
    const queryParamRegex = '^(?!  )[A-Za-z0-9-_:]+$';
    if (RegExp(queryParamRegex).test(queryParam)) {
        return true;
    }
    if (request !== null) {
        request.log('info', {
            category: 'icid',
            event: 'Invalid icid',
            queryParam
        });
    }
    return false;
};

export const collapseQueryParams = (queryParams = {}, baseUrl = '', request) => {
    if (Object.keys(queryParams).length === 0) {
        return '';
    }

    const keys = Object.keys(queryParams);
    // eslint-disable-next-line no-mixed-operators
    const filteredKeys = keys.filter((x) => x !== 'icid' || x === 'icid' && isValidIcid(queryParams[x], request));
    const kvPairs = filteredKeys.map((key) => `${key}=${encodeURIComponent(queryParams[key])}`);
    if (kvPairs.length === 0) return '';
    const firstDelimiter = baseUrl.indexOf('?') === -1 ? '?' : '&';
    return `${firstDelimiter}${kvPairs.join('&')}`;
};

// Params that carry a redirect target, which has a query string of its own.
const REDIRECT_PARAM_KEYS = ['redirectUri', 'redirect_uri', 'returnUrl', 'return_url'];

const nestedKeys = (existingParams) => REDIRECT_PARAM_KEYS.reduce((keys, key) => {
    const target = existingParams.get(key);
    const queryIndex = target ? target.indexOf('?') : -1;
    if (queryIndex !== -1) {
        new URLSearchParams(target.slice(queryIndex + 1)).forEach((value, nestedKey) => keys.add(nestedKey));
    }
    return keys;
}, new Set());

export const filterOutExistingParams = (queryParams, url = '') => {
    const queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
        return queryParams;
    }
    const existingParams = new URLSearchParams(url.slice(queryIndex + 1));
    const takenKeys = nestedKeys(existingParams);
    existingParams.forEach((value, key) => takenKeys.add(key));
    return Object.fromEntries(Object.entries(queryParams || {}).filter(([key]) => !takenKeys.has(key)));
};

export const appendQueryParams = (link, queryParams) => {
    const filteredQuery = filterOutExistingParams(queryParams, link);
    const queryIndex = link.indexOf('?');
    const existingParams = new URLSearchParams(queryIndex === -1 ? '' : link.slice(queryIndex + 1));
    const redirectKey = REDIRECT_PARAM_KEYS.find((key) => existingParams.has(key));
    if (!redirectKey) {
        return `${link}${collapseQueryParams(filteredQuery, link, null)}`;
    }
    const target = existingParams.get(redirectKey);
    const nestedQuery = collapseQueryParams(filteredQuery, target, null);
    if (nestedQuery === '') {
        return link;
    }
    const pairs = link.slice(queryIndex + 1).split('&').map((pair) => (
        pair.split('=')[0] === redirectKey ? `${redirectKey}=${encodeURIComponent(`${target}${nestedQuery}`)}` : pair
    ));
    return `${link.slice(0, queryIndex)}?${pairs.join('&')}`;
};

export const canonicalizeUuid = (uuid) => {
    const uLength = uuid.length;
    let canonicalForm = uuid; // assume it is in canonical form
    if (uLength !== 36 && uLength !== 32) {
        canonicalForm = '-1';
    }
    if (uLength === 32) {
        const re = /(.{8})(.{4})(.{4})(.{4})(.{12})/;
        canonicalForm = uuid.replace(re, '$1-$2-$3-$4-$5');
    }

    return canonicalForm;
};

export const isEmpty = (str) => !str || str === '';

export const isNotEmpty = (str) => !isEmpty(str);

export default {
    collapseQueryParams,
    filterOutExistingParams,
    appendQueryParams,
    canonicalizeUuid
};
